module.exports = __webpack_public_path__ + "static/media/ils-share-video.d3496008.svg";